const PrivacyPolicy = () => {
  return (
    <div className="privacyPolicy contento">
      <div className="container">
        <section>
          <h2>Privacy Policy – Gr8 Appers</h2>
          {/* Effective Date: [Insert Date] */}
          <p className="lgText">
            Gr8 Appers respects your privacy and is committed to protecting your
            personal data. This policy explains how we collect, use, and store
            your information.
          </p>
        </section>
        <section>
          <h4>1. Information We Collect</h4>
          <ul>
            <li>
              {" "}
              Personal information like name, phone number, email, and
              educational background.
            </li>
            <li> Assessment results and responses.</li>
            <li> Website usage data through cookies (non-personal).</li>
          </ul>
        </section>
        <section>
          <h4>2. How We Use Your Data</h4>
          <ul>
            <li>To provide personalized counseling and guidance.</li>
            <li>To communicate with you via email, phone, or WhatsApp.</li>
            <li>To improve our website and services.</li>
            <li>
              To send updates, offers, and information (you may opt out any
              time).
            </li>
          </ul>
        </section>
        <section>
          <h4>3. Data Sharing</h4>
          <p className="mdText">
            We do not sell or share your data with third parties, except:
          </p>
          <ul>
            <li>With your permission (e.g., university applications).</li>
            <li>If required by law or regulatory authorities.</li>
          </ul>
        </section>
        <section>
          <h4>4. Data Security</h4>
          <p>
            {" "}
            We use secure systems and encryption to store your data. However, we
            cannot guarantee 100% security due to the nature of the internet.
          </p>
        </section>
        <section>
          <h4>5. Cookies</h4>
          <p className="mdText">
            We use cookies to track website performance and user behavior. You
            can choose to disable cookies in your browser settings.
          </p>
        </section>
        <section>
          <h4>6. Children’s Privacy</h4>
          <p className="mdText">
            Our services are directed to students above age 13. Parents or
            guardians must give consent for children under 13.
          </p>
        </section>
        <section>
          <h4>7. Your Rights</h4>
          <p className="mdText">
            We do not sell or share your data with third parties, except:
          </p>
          <ul>
            <li>
              You can request to view, update, or delete your personal data.
            </li>
            <li>You can unsubscribe from promotional communication.</li>
          </ul>
        </section>
        <section>
          <h4>8. Contact Us</h4>
          <p className="mdText">
            For privacy-related concerns, email us at: <a href="mailto:contact@gr8appers.com">contact@gr8appers.com</a> 
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
